export const DURATION_FULL_DAY = '24:00';
export const DURATION_HALF_DAY = '12:00';
